<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col cols="12">
                <v-select
                  v-model="form.type"
                  :items="items"
                  :rules="[rules.required]"
                  label="Tipo de Usuario"
                  :disabled="disabled"
                  required
                />
              </v-col>

              <v-col v-if="form.type === 'PAC'" cols="12">
                <v-select
                  v-model="form.role"
                  :items="items_role"
                  :rules="[rules.required]"
                  label="Rol de usuario"
                  @change="selectRol()"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.name"
                  :rules="[rules.required]"
                  :maxlength="100"
                  label="Nombre"
                  placeholder="Pedro Perez"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.email"
                  :rules="[rules.required, rules.emailRules]"
                  label="Correo Electrónico"
                  placeholder="ejemplo@dominio.com"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.identificator"
                  :rules="[rules.identificatorFormat, rules.identificatorLength]"
                  :maxlength="20"
                  label="Identificación"
                  placeholder="Cédula"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.phone"
                  :rules="[rules.phoneFormat]"
                  label="Teléfono"
                  placeholder="####-#### / ######-####-####"
                  maxlength="16"
                />
              </v-col>

              <v-col
                v-if="form.type === 'PAC'"
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.cat_province_id"
                  :items="itemsProvince"
                  item-value="id"
                  item-text="name"
                  label="Provincia"
                  @change="getDistrito()"
                />
              </v-col>

              <v-col
                v-if="form.type === 'PAC'"
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.cat_district_id"
                  :items="itemsDistrict"
                  item-value="id"
                  item-text="name"
                  label="Distrito"
                  @change="getCorregimiento()"
                />
              </v-col>

              <v-col
                v-if="form.type === 'PAC'"
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.cat_corregimiento_id"
                  :items="itemsCorregimiento"
                  item-value="id"
                  item-text="name"
                  label="Corregimiento"
                />
              </v-col>

              <v-col
                v-if="form.type === 'PAC'"
                cols="12"
              >
                <v-text-field
                  v-model="form.address"
                  maxlength="100"
                  label="Dirección"
                  placeholder="Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá"
                />
              </v-col>
              <v-col v-if="form.type === 'PAC'" cols="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Acción
                        </th>
                        <th class="text-left">
                          Activo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in items_permission"
                        :key="item.id"
                      >
                        <td>{{ item.description }}</td>
                        <td>
                          <v-switch
                            :color="themeColor"
                            v-model="form.items_permission"
                            :value="item.id"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import { mask } from 'vue-the-mask';
  import { mapGetters } from 'vuex';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    metaInfo() {
      return { title: this.$t('enterprises') };
    },
    components: {
      FormToolbar,
    },
    directives: {
      mask,
    },
    props: {
      id: { default: null },
      idUsuario: { default: '' },
      type: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: null,
        name: null,
        email: null,
        type: null,
        identificator: null,
        phone: null,
        cat_corregimiento_id: null,
        cat_district_id: null,
        cat_province_id: null,
        address: null,
        active: '1',
        busy: false,
        role: null,
        items_permission: [],
      }),
      items_role: [],
      items_permission: [],
      fel: null,
      pac: null,
      disabled: false,
      itemsProvince: [],
      itemsDistrict: [],
      itemsCorregimiento: [],
      errores: null,
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        emailRules: (v) => /.+@.+\..+/.test(v) || 'Debe introducir un correo electrónico válido.',
        identificatorLength: (v) => (!v || (v.length >= 5 && v.length <= 20)) || 'El campo debe tener de 5 a 20 caracteres.',
        phoneFormat: (v) => (
            /^[0-9-]+$/.test(v) && /^(?:\d{3,4}-\d{4}|\d{6}-\d{3,4}-\d{4})$/.test(v)
        ) || 'El campo debe seguir el formato ###-####, ####-####, ######-###-#### o ######-####-####.',
        identificatorFormat: (v) => /^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || 'El campo debe tener un formato válido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Usuario',
      apiURL: '/api/enterprises',
      apiURLUser: 'users/store',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
      items() {
        const items = [];
        if (this.fel) items.push('FEL');
        if (this.pac) items.push('PAC');

        return items;
      },
      enterprise() {
        return this.$store.state.profile.enterprise;
      },
      ...mapGetters({
        themeColor: 'theme/themeColor',
      }),
    },
    watch: {
      'form.cat_province_id': {
        handler() {
          this.getDistrito();
        },
      },
      'form.cat_district_id': {
        handler() {
          this.getCorregimiento();
        },
      },
    },
    async mounted() {
      window.axios.get(`/api/enterprises/${this.enterprise.id}`)
      .then((response) => {
        this.fel = response.data.fel_id;
        this.pac = response.data.pac_id;
      });

      await this.getProvincia().then((response) => {
        this.itemsProvince = response.data;
      });
      const URL = `${this.apiURL}/${this.id}/${this.apiURLUser}`;
      this.URL = URL;
      if (this.idUsuario) {
        window.axios.get(`${this.apiURL}/${this.id}/users/${this.idUsuario}/type/${this.type}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          if (this.type === 'FEL') this.form.identificator = result.data.identification_number;
          this.disabled = true;
          this.URL = `${this.apiURL}/${this.id}/users/${this.idUsuario}/type/${this.type}/update`;
          this.method = 'PUT';
          this.title = 'Editar Usuario';
          this.message = `Se ha editado el usuario ${result.data.name} exitosamente.`;
          if (this.type === 'PAC') {
            this.selectRol();
            const permissions = result.data.permissions.map((permission) => (permission.id));
            this.form.items_permission = permissions;
          }
        });
      }
      await this.getRoles().then((response) => {
        const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
        this.items_role = roles;
      });
    },
    methods: {
      selectRol() {
        const url = `/api/maintenance/roles/permissions/${this.form.role}`;
            window.axios.get(url)
            .then((response) => {
            this.items_permission = response.data;
        });
      },
      getRoles() {
        const type = 'C';
        const url = `/api/users/getRoles/${type}`;
        return window.axios.get(url);
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
     store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then((result) => {
            this.$router.push({ name: 'enterprise.users', params: { action: 'created', message: result.data.message } });
        }).catch(() => {
            this.form.busy = false;
        });
      },
      getProvincia() {
        const url = '/api/provinces';
        return window.axios.get(url);
      },
      getDistrito() {
        if (this.form.cat_province_id) {
            const url = `/api/districts/${this.form.cat_province_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsDistrict = response.data;
          });
        }
      },
      getCorregimiento() {
        if (this.form.cat_district_id) {
            const url = `/api/corregimientos/${this.form.cat_district_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsCorregimiento = response.data;
          });
        }
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.form = new Form({
          id: null,
          name: null,
          email: null,
          type: null,
          identificator: null,
          phone: null,
          cat_corregimiento_id: null,
          cat_district_id: null,
          cat_province_id: null,
          address: null,
          active: '1',
          busy: false,
          role: null,
          items_permission: [],
        });
        this.resetValidation();
        this.title = 'Nuevo Usuario';
        this.disabled = false;
        this.URL = `${this.apiURL}/${this.enterpriseId}/users/store`;
        this.method = 'POST';
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
